import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getOverrides, useClasses } from '../../../utils/overrides';
import CheckedIcon from './CheckedIcon';
import UncheckedIcon from './UncheckedIcon';
import { createUseStyles } from '../../../utils/styles';
import styles from './styles';
const useStyles = createUseStyles(styles, 'Radio');
function Radio(_ref) {
  let {
    checked,
    classes: classesProp,
    className: classNameProp,
    isDisabled,
    onChange,
    overrides: overridesProp,
    ...props
  } = _ref;
  const classes = useClasses(useStyles, classesProp);
  // Overrides
  const override = getOverrides(overridesProp, Radio.overrides);

  // Classes
  const rootClassName = classnames(classes.root, {
    [classes.disabled]: isDisabled
  }, classNameProp);
  const rootProps = {
    className: rootClassName,
    onClick: !isDisabled ? onChange : undefined
  };
  return /*#__PURE__*/React.createElement("div", _extends({}, rootProps, override.root), checked && /*#__PURE__*/React.createElement(CheckedIcon, override.svg), !checked && /*#__PURE__*/React.createElement(UncheckedIcon, override.svg), /*#__PURE__*/React.createElement("input", _extends({
    className: classes.input,
    onChange: !isDisabled ? onChange : undefined,
    type: "radio",
    checked: checked ? 'checked' : '',
    disabled: isDisabled ? 'disabled' : ''
  }, override.input)));
}
Radio.overrides = ['root', 'input', 'svg'];
Radio.defaultProps = {
  checked: false,
  onChange: () => {},
  overrides: {}
};
process.env.NODE_ENV !== "production" ? Radio.propTypes = {
  checked: PropTypes.bool,
  className: PropTypes.string,
  isDisabled: PropTypes.bool,
  onChange: PropTypes.func,
  overrides: PropTypes.object
} : void 0;
export default /*#__PURE__*/React.memo(Radio);